import request from '../request.js'

// 租户角色预设 列表
const selectTenantPreinstall = function () {
    return request({
        url: 'sysTenantPreinstall/list',
        method: 'post'
    })
}

// 租户角色预设 添加/编辑
const insertTenantPreinstall = function (data) {
    return request({
        url: 'sysTenantPreinstall/saveOrUpdate',
        method: 'post',
        data
    })
}

// 租户角色预设 删除
const deleteTenantPreinstall = function (data) {
    return request({
        url: 'sysTenantPreinstall/deleteById',
        method: 'post',
        data
    })
}

// 租户角色预设 查询单条
const getRoleListById = function (data) {
    return request({
        url: 'sysTenantPreinstallRole/getRoleListById',
        method: 'post',
        data
    })
}

// 租户角色预设 点击保存
const insertTenantPreinstallRole = function (data) {
    return request({
        url: 'sysTenantPreinstallRole/insert',
        method: 'post',
        data
    })
}

// 获取主体 列表
const selectLimitall = function () {
    return request({
        url: 'sysLimit/selectAll',
        method: 'post'
    })
}

// 获取主体 查询单条
const getRolesByLimitId = function (data) {
    return request({
        url: 'sysLimitRole/getRolesByLimitId',
        method: 'post',
        data
    })
}

// 主体 新增/编辑
const saveOrUpdateLimit = function (data) {
    return request({
        url: 'sysLimit/saveOrUpdate',
        method: 'post',
        data
    })
}

// 获取主体 查询单条
const saveRoleLimits = function (data) {
    return request({
        url: 'sysLimitRole/saveRoleLimits',
        method: 'post',
        data
    })
}

// 获取主体 删除
const deleteLimits = function (data) {
    return request({
        url: 'sysLimit/deleteById',
        method: 'post',
        data
    })
}

export { selectTenantPreinstall, insertTenantPreinstall, deleteTenantPreinstall,
    getRoleListById, insertTenantPreinstallRole, selectLimitall, getRolesByLimitId,
    saveOrUpdateLimit, saveRoleLimits, deleteLimits }